var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-input',{attrs:{"value":_vm.value,"clearable":_vm.clearable,"placeholder":_vm.placeholder},on:{"input":_vm.onChange}})}
var staticRenderFns = []

export { render, staticRenderFns }